import axios from "axios";
import { BaseUrl, NewUpdatedBaseUrl } from "../../BaseUrl/BaseUrl";
import Mylogo from "../../assets/images/new/newLogo.jpg";
import { GetProfileDetails, GetUserModel } from "../../ApiServices/Profile/ProfileApi";


const getUserId = () => localStorage.getItem("userID");
const getuserKeyID = () => localStorage.getItem("userKeyID");
// const userKeyID = localStorage.getItem("userKeyID");
const RazorPayKey = process.env.RazorPayKey;
const RazorPaySecretKey = process.env.RazorPaySecretKey;
const RazorPayName = process.env.RazorPayName;
const generateReceiptId = () => `rcpt_${new Date().getTime()}`;

const createRazorpayOrder = async (amount, receiptID) => {
    const response = await axios.post(`${NewUpdatedBaseUrl}/RazorPay/create-order?isProd=true`, {
        amount,
        receipt: receiptID,
    });
    return response?.data?.orderId;
};

const verifyRazorpayPayment = async ({ razorpay_payment_id, razorpay_order_id, razorpay_signature, userID, orderID, amount }) => {
    try {
        const res = await axios.post(`${NewUpdatedBaseUrl}/RazorPay/verify-payment?isProd=true`, {
            useR_ID: userID,
            orderId: orderID,
            paymentId: razorpay_payment_id,
            orderId: razorpay_order_id,
            signature: razorpay_signature,
            paymentAmount: amount,
        });
        return res.data.status === "success"
            ? { status: 1, razorpay_payment_id }
            : { status: 0 };
    } catch (error) {
        console.error("Payment verification error", error);
        throw error;
    }
};

const openRazorpayPopup = (options) => {
    const rzp = new window.Razorpay(options);
    rzp.open();
};

export const handleProceedRemainingPayment = async (Remaining_Amount) => {
    const userID = getUserId();
    const keyID = getuserKeyID();
    let mobileNumber = ""
    const response = await GetProfileDetails(keyID);
    if (response?.statusCode === 200) {
        // setLoader(false);

        const ModelData = response?.responseData?.data || []; // Assuming the data is an array and we need the first item
        mobileNumber = ModelData?.mobileNo

    } else {
        // setLoader(false);

        console.error(
            "Error fetching data: ",
            response?.data?.data?.statusCode
        );
    }


    if (Remaining_Amount === 0) {
        alert("All the amount already paid");
        return { status: 0 };
    }

    const receiptID = generateReceiptId();
    const orderID = await createRazorpayOrder(Remaining_Amount, receiptID);

    return new Promise((resolve, reject) => {
        const options = {
            key: RazorPayKey,
            key_secret: RazorPaySecretKey,
            amount: Remaining_Amount * 100,
            currency: "INR",
            name: RazorPayName,
            description: "Remaining Payment",
            image: Mylogo,
            order_id: orderID,
            prefill: {
                // name: "Myomnamo",   // optional
                // email: "customer@email.com", // optional
                contact: mobileNumber,   // phone number here
            },
            handler: async function (response) {
                const result = await verifyRazorpayPayment({
                    ...response,
                    userID,
                    orderID,
                    amount: Remaining_Amount,
                });
                resolve(result);
            },
            modal: {
                ondismiss: () => {
                    console.warn("User closed Razorpay modal");
                    resolve({ status: 0 });
                },
            },
            theme: {
                color: "#ff416c",
            },
        };

        openRazorpayPopup(options);
    });
};



